import { render, staticRenderFns } from "./SwitchButton.vue?vue&type=template&id=0dbb750e&scoped=true&"
import script from "./SwitchButton.vue?vue&type=script&lang=ts&"
export * from "./SwitchButton.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchButton.vue?vue&type=style&index=0&id=0dbb750e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbb750e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
